import { Navigate } from 'react-router-dom';

import {
  EnvironmentalAndSocialRisks,
  ExecutiveSummary,
  GhgRating,
  LazyRoute,
  PricingAndSupply,
  RelatedContent,
  SDGRating,
} from '../lazyImports';

export const projectDetailChildren = (loaderCallback: any) => [
  {
    path: 'executive_summary',
    element: <LazyRoute Component={ExecutiveSummary} />,
    loader: loaderCallback,
  },
  {
    path: 'ghg_rating',
    element: <LazyRoute Component={GhgRating} />,
    handle: { breadcrumb: 'GHG rating' },
  },
  {
    path: 'esr_rating',
    element: <LazyRoute Component={EnvironmentalAndSocialRisks} />,
    handle: { breadcrumb: 'ESR rating' },
    children: [
      {
        path: 'detailed_risk_findings',
        element: <LazyRoute Component={EnvironmentalAndSocialRisks} />,
      },
      {
        path: 'project_comparison',
        element: <LazyRoute Component={EnvironmentalAndSocialRisks} />,
      },
      {
        path: 'further_research',
        element: <LazyRoute Component={EnvironmentalAndSocialRisks} />,
      },
      {
        path: 'sources_and_methodology',
        element: <LazyRoute Component={EnvironmentalAndSocialRisks} />,
      },
    ],
  },
  {
    path: 'ess_rating',
    element: <Navigate to={`/esr_rating${window.location.search}`} replace />,
  },
  {
    path: 'ess_rating/detailed_risk_findings',
    element: (
      <Navigate to={`/esr_rating/detailed_risk_findings${window.location.search}`} replace />
    ),
  },
  {
    path: 'ess_rating/project_comparison',
    element: <Navigate to={`/esr_rating/project_comparison${window.location.search}`} replace />,
  },
  {
    path: 'ess_rating/further_research',
    element: <Navigate to={`/esr_rating/further_research${window.location.search}`} replace />,
  },
  {
    path: 'ess_rating/sources_and_methodology',
    element: (
      <Navigate to={`/esr_rating/sources_and_methodology${window.location.search}`} replace />
    ),
  },
  {
    path: 'related_content',
    element: <LazyRoute Component={RelatedContent} />,
    handle: { breadcrumb: 'Related content' },
  },
  {
    path: 'sdg_rating',
    element: <LazyRoute Component={SDGRating} />,
    handle: { breadcrumb: 'SDG rating' },
  },
  {
    path: 'pricing_and_supply',
    element: <LazyRoute Component={PricingAndSupply} />,
    handle: { breadcrumb: 'Pricing & supply' },
  },
];
